(function () {
    'use strict';
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    document.querySelectorAll('.scrolltext').forEach(function (section) {
        var inner = section.querySelector('.scrolltext__inner');
        if (!inner) return;

        var textWidth = inner.scrollWidth;
        var viewportWidth = window.innerWidth;
        // Posun jen o 60% celkové vzdálenosti — pomalejší pohyb
        var totalDistance = (textWidth + viewportWidth) * 0.6;

        gsap.fromTo(inner,
            { x: viewportWidth },
            {
                x: -totalDistance,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 2
                }
            }
        );
    });
})();
